module.exports = __webpack_public_path__ + "img/training.ac37046e.png";